import { render, staticRenderFns } from "./special-data.vue?vue&type=template&id=19daec53"
import script from "./special-data.vue?vue&type=script&lang=ts"
export * from "./special-data.vue?vue&type=script&lang=ts"
import style0 from "./special-data.vue?vue&type=style&index=0&id=19daec53&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports